import { FavouriteTransfer, FavouriteTransferResponseDTO } from '../entities';

const favouriteTransferDTOToFavouriteTransferAdapter = (data: FavouriteTransferResponseDTO): FavouriteTransfer => {
  if (!data.body) {
    throw new Error('Error');
  }

  const favouriteTransferDTO = data.body;

  return new FavouriteTransfer(
    favouriteTransferDTO.name,
    favouriteTransferDTO.id,
    favouriteTransferDTO.shared,
    favouriteTransferDTO.owned,
    favouriteTransferDTO.data.debitAccountNumber,
    favouriteTransferDTO.data.creditAccountNumber,
    favouriteTransferDTO.data.orderCurrency,
    favouriteTransferDTO.data.currencyDescription,
    favouriteTransferDTO.data.orderAmount,
    favouriteTransferDTO.data.creditAccountType,
    favouriteTransferDTO.data.receiverComments,
    favouriteTransferDTO.data.receiverBic,
    favouriteTransferDTO.data.receiverAddress,
    favouriteTransferDTO.data.receiverFullName,
    favouriteTransferDTO.data.receiverFullNameMasked,
    favouriteTransferDTO.data.chargingMethod,
    favouriteTransferDTO.data.chargingMethodDescription,
    favouriteTransferDTO.data.countrySn,
    favouriteTransferDTO.data.bankCountrySn,
    favouriteTransferDTO.data.countryDescription,
    favouriteTransferDTO.data.countryShortDescription,
    favouriteTransferDTO.data.additionalGlobalOrdersDetailBicBankCode,
    favouriteTransferDTO.data.additionalGlobalOrdersDetailInnTaxPayerCode,
    favouriteTransferDTO.data.additionalGlobalOrdersDetailCorCbr,
    favouriteTransferDTO.data.additionalGlobalOrdersDetailKppBeneficiary,
    favouriteTransferDTO.data.additionalGlobalOrdersDetailVocGhCode,
    favouriteTransferDTO.data.additionalGlobalOrdersDetailVocGdCode,
    favouriteTransferDTO.data.additionalGlobalOrdersDetailBopGh,
    favouriteTransferDTO.data.additionalGlobalOrdersDetailBopGd,
    favouriteTransferDTO.data.receiverSortCode,
    favouriteTransferDTO.data.bankName,
    favouriteTransferDTO.data.receiverCity,
    favouriteTransferDTO.data.priorityDate,
  );
};

export { favouriteTransferDTOToFavouriteTransferAdapter };
